import * as Yup from "yup";

export const Schema = Yup.object().shape({
    faName: Yup.string().required("فیلد نام فارسی الزامی می باشد"),
    enName: Yup.string().required("فیلد نام انگلیسی الزامی می باشد"),
    seoName: Yup.string().required("فیلد نام سئو الزامی می باشد"),
    url: Yup.string().required("فیلد آدرس الزامی می باشد"),
    price: Yup.string().required("فیلد مبلغ الزامی می باشد"),
});
